import React, { FC } from "react"
import { graphql } from "gatsby"
import { FluidObject } from "gatsby-image"
import { navigate } from "@reach/router"
//layout
import Layout from "../components/layout/layout"
//component
import LandingSection from "../components/reuseableComponents/landingSec"
import BlogContent from "../components/templateComponents/blogTemplatePage/blogContent"
import AuthorTitle from "../components/reuseableComponents/authorTitle"
import BlogComments from "../components/templateComponents/blogTemplatePage/blogComments"
import BlogsSidebar from "../components/blogsSidebar/blogsSidebar"

//type
import { authorType } from "../types/author_TYPE"
import { commentsType } from "../types/comment_TYPE"
import { Box, Grid, Hidden } from "@material-ui/core"
//auth
import { isLoggedIn } from "../utils/auth"
import { Helmet } from "react-helmet"

interface props {
  data: {
    Blog: {
      title: string
      date: Date
      likes: number
      slug: string
      description: {
        description: string
      }
      blogImage: {
        fluid: FluidObject
      }
      author: authorType
      comments: commentsType[]
    }
  }
}

// if (window.location.pathname.match("/blogs/*")) {
//   if (!isLoggedIn()) {
//     navigate(`/app/login`)
//   }
// }
const BlogTemplate: FC<props> = ({ data: { Blog } }) => {
  return (
    <Layout>
      <Helmet title={`Explorer-${Blog.slug}`} defer={false} />
      <LandingSection
        title={Blog.title}
        image={Blog.blogImage}
        textType={"short"}
      />
      <div className="container">
        <Grid container spacing={2}>
          <Grid item md={8} xs={12}>
            <AuthorTitle
              authorName={Blog.author.authorName}
              authorImage={Blog.author.authorImage}
              date={Blog.date}
            />
            <BlogContent
              description={Blog.description.description}
              blogTitle={Blog.title}
            />

            <Box mb={8}>
              <BlogComments Likes={Blog.likes} commentData={Blog.comments} />
            </Box>
          </Grid>
          <Hidden smDown>
            <Grid item md={4}>
              <BlogsSidebar />
            </Grid>
          </Hidden>
        </Grid>
      </div>
    </Layout>
  )
}

export default BlogTemplate

//data
export const query = graphql`
  query GetBlog($slug: String) {
    Blog: contentfulBlogPost(slug: { eq: $slug }) {
      title
      date
      slug
      blogImage {
        fluid {
          ...GatsbyContentfulFluid
        }
      }
      author {
        authorName
        authorImage {
          fluid {
            ...GatsbyContentfulFluid
          }
        }
      }
      description {
        description
      }
      likes
      comments {
        commentDateTime
        authorComment {
          authorName
          slug
          authorImage {
            fluid {
              ...GatsbyContentfulFluid
            }
          }
        }
        comment
      }
    }
  }
`
